import { render, staticRenderFns } from "./HomeHeroSummary.vue?vue&type=template&id=0da72ef1&scoped=true"
import script from "./HomeHeroSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeHeroSummary.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./HomeHeroSummary.vue?vue&type=style&index=0&id=0da72ef1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da72ef1",
  null
  
)

export default component.exports